import {
  MULTISELECT,
  SELECT,
  TEXT,
  AREA,
  MIN_MAX,
  AUTOCOMPLETE,
  DATE_RANGE,
  DATA_STREAM_MULTISELECT,
  DATA_STREAM_MIN_MAX,
  DATA_STREAM_DATE_RANGE,
  TITLE,
} from './filter-types';

export const title = (label) => {
  const filter = {
    label,
    type: TITLE,
  };

  return filter;
};

export const text = ({
  key,
  source,
  label,
  multikey,
  operator = 'contains',
  options,
  unit,
  filterString,
  prepend,
  postpend,
}) => {
  const filter = {
    key,
    source,
    label,
    unit,
    filterString,
    prepend,
    postpend,
    multikey,
    operator,
    type: TEXT,
  };

  if (options) filter.options = options;
  return filter;
};
export const multiselect = ({
  key,
  source,
  label,
  multikey,
  operator,
  options,
  unit,
  filterString,
}) => {
  const filter = {
    key,
    source,
    label,
    unit,
    filterString,
    multikey,
    operator,
    type: MULTISELECT,
  };

  if (options) filter.options = options;
  return filter;
};

export const dataStreamMultiselect = ({ label, dataFieldId, unit, filterString }) => ({
  key: `string_value+${dataFieldId}`,
  label,
  unit,
  dataFieldId,
  filterString: [
    `data_stream_field_id=${dataFieldId}&source=data_point`,
    filterString,
  ].filter(Boolean).join('&'),
  type: DATA_STREAM_MULTISELECT,
});

export const select = ({
  key,
  source,
  label,
  multikey,
  operator,
  options,
  unit,
  filterString,
}) => {
  const filter = {
    key,
    source,
    label,
    unit,
    filterString,
    multikey,
    operator,
    type: SELECT,
  };

  if (options) filter.options = options;
  return filter;
};

export const area = () => ({
  key: 'area_filter',
  label: 'Draw Layer',
  operator: 'inside',
  type: AREA,
});

export const minMax = ({
  label,
  key,
  unit,
  filterString,
  source,
}) => ({
  key,
  source,
  label,
  unit,
  filterString,
  operator: 'inside',
  type: MIN_MAX,
});

export const dataStreamMinMax = ({ label, dataFieldId, unit, filterString }) => ({
  key: `number_value+${dataFieldId}`,
  label,
  unit,
  operator: 'inside',
  dataFieldId,
  filterString: [
    `data_stream_field_id=${dataFieldId}&source=data_point`,
    filterString,
  ].filter(Boolean).join('&'),
  type: DATA_STREAM_MIN_MAX,
});

export const autocomplete = ({
  key, source, label, options, unit, filterString,
}) => {
  const filter = {
    key,
    source,
    label,
    unit,
    filterString,
    operator: 'contains',
    type: AUTOCOMPLETE,
  };

  if (options) filter.options = options;
  return filter;
};

export const dateRange = ({
  key,
  source,
  label,
  unit,
  filterString,
}) => {
  const filter = {
    key,
    source,
    label,
    unit,
    filterString,
    type: DATE_RANGE,
  };

  return filter;
};

export const dataStreamDateRange = ({
 dataFieldId, label, key, unit, filterString,
}) => {
  const filter = {
    key: `${key}+${dataFieldId}`,
    unit,
    dataFieldId,
    label,
    type: DATA_STREAM_DATE_RANGE,
    filterString: [
      `data_stream_field_id=${dataFieldId}&source=data_point`,
      filterString,
    ].filter(Boolean).join('&'),
  };

  return filter;
};
